export default "__VITE_ASSET__B1YeH6rG__"